angular.module('vskoProgressBar', [])

.constant('vskoProgressBarConfig', {
  animate: true,
  max: 100,
})
.directive('vskoProgressBar', ['vskoProgressBarConfig', function(vskoProgressBarConfig) {
  return {
    replace: false,
    transclude: true,
    scope: {
      value: '=',
      max: '=?',
      type: '@',
      title: '@',
      active: '=?',
      animate: '=?',
      striped: '=?'
    },
    template: require('./vsko-progress-bar.html'),
    link: function(scope, element, attrs) {
       'use strict';
       var animate = scope.animate || vskoProgressBarConfig.animate;
       if (!animate) {
          element.css({'transition': 'none'});
       }

       scope.max = scope.max || vskoProgressBarConfig.max;
       scope.recalculatePercentage = function() {
          scope.percent = +(100 * scope.value / scope.max).toFixed(2);
          if (scope.percent > 100) {
            scope.percent = 100;
          }
        };
        scope.recalculatePercentage();

        scope.$watch('value', function(value) {
            scope.recalculatePercentage();
        });

        scope.$watch('max', function(maxParam) {
            scope.recalculatePercentage();
        });

        scope.getStyleClass = function() {
          var styles = [];
          if (scope.type) {
            styles.push('progress-bar-' + scope.type);
          }
          if (scope.active) {
            styles.push('active');
          }
          if (scope.striped) {
            styles.push('progress-bar-striped' );
          }
          return styles.join(" ");
        }
    }
  };
}]);
